import { AGENCY_INFO } from '../data/content';
import BrandLogo from './BrandLogo';
import { ArrowUp, Mail } from 'lucide-react';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const officialEmails = [
    { label: 'General & Prensa', email: AGENCY_INFO.emails.general },
  ];

  return (
    <footer className="bg-[#070d14] border-t border-slate-800 text-slate-300 pt-16 pb-28 md:pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-slate-800">
          {/* Brand Info */}
          <div className="md:col-span-5 space-y-4">
            <BrandLogo size="md" textColor="text-white" />
            <p className="text-xs text-slate-400 leading-relaxed max-w-sm pt-1">
              Consultora de comunicación estratégica y posicionamiento digital. Transformamos mensajes en autoridad, reputación e influencia real.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-3 space-y-3">
            <p className="text-xs font-bold text-white uppercase tracking-widest">Navegación</p>
            <ul className="grid grid-cols-1 gap-2 text-xs font-medium text-slate-400">
              <li><a href="#servicios" className="hover:text-cyan-400 transition-colors">Servicios</a></li>
              <li><a href="#planes" className="hover:text-cyan-400 transition-colors">Planes</a></li>
              <li><a href="#por-que-epica" className="hover:text-cyan-400 transition-colors">Por qué ÉPICA</a></li>
              <li><a href="#metodologia" className="hover:text-cyan-400 transition-colors">Metodología</a></li>
              <li><a href="#equipo" className="hover:text-cyan-400 transition-colors">Equipo Directivo</a></li>
              <li><a href="#contacto" className="hover:text-cyan-400 transition-colors">Contacto Directo</a></li>
            </ul>
          </div>

          {/* Official Email Mailboxes */}
          <div className="md:col-span-4 space-y-3">
            <p className="text-xs font-bold text-white uppercase tracking-widest">Casillas de Correo</p>
            <div className="space-y-2 text-xs">
              {officialEmails.map((box) => (
                <div key={box.email} className="p-2.5 rounded-xl bg-slate-900 border border-slate-800">
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{box.label}</p>
                  <a
                    href={`mailto:${box.email}`}
                    className="font-mono text-xs text-cyan-300 hover:underline flex items-center gap-1.5 mt-0.5"
                  >
                    <Mail className="w-3.5 h-3.5 shrink-0 text-cyan-500" />
                    <span className="truncate">{box.email}</span>
                  </a>
                </div>
              ))}
            </div>
            <p className="text-[11px] text-slate-400 pt-1">Teléfonos / WhatsApp: {AGENCY_INFO.phoneDisplayCombined}</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© 2026 ÉPICA Consultora de Comunicaciones. Todos los derechos reservados.</p>
          <p className="font-medium text-slate-400">Dirigida por {AGENCY_INFO.directorsNames}.</p>

          <button
            onClick={scrollToTop}
            className="p-2.5 rounded-full bg-slate-900 hover:bg-slate-800 text-slate-200 border border-slate-700 transition-colors flex items-center gap-1.5"
          >
            <ArrowUp className="w-4 h-4" />
            <span>Volver arriba</span>
          </button>
        </div>
      </div>
    </footer>
  );
}
